import dograh from "./dograhHandler";
import eventTap from "./dograhEventTap";
import sarvamTts from "./sarvamTtsHandler";
import wakeWord from "./wakeWordHandler";

const API = {
	...dograh,
	...eventTap,
	...sarvamTts,
	...wakeWord,
};
export default API;
